export default __webpack_public_path__ + "static/media/bg.34beffca.png";